if (!customElements.get('mr-point')) {
  class MrPoint extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      // サーバー側に記載されてるエラーメッセージもあるので、いったん静的に記載しておく。後追いで動的に値を設定できる形にできないか検討
      this.emptyErrorMessage = 'ポイントを入力してください。';

      this.customerId = this.dataset.customerId;
      const customerTagStr = this.dataset.customerTags;
      this.customerTags = customerTagStr ? customerTagStr.split(',') : [];
      this.totalSpent = this.dataset.totalSpent ? Number(this.dataset.totalSpent) : 0;
      this.blockType = this.dataset.blockType;
      this.secretKey = this.dataset.secretProxyKey;
      this.elContainer = this.querySelector('.js-container');
      this.elCurrentPointValue = this.querySelector('.js-current-point-value');
      this.elRankValue = this.querySelector('.js-rank-value');
      this.elUseButton = this.querySelector('.js-use-button');
      this.elResetButton = this.querySelector('.js-reset-button');
      this.elUsePoint = this.querySelector('.js-use-point');
      this.elDiscountValue = this.querySelector('.js-point-discount-value');
      this.elApplyPointValue = this.querySelector('.js-apply-point-value');
      this.elUsePointInput = this.querySelector('.js-use-point-input');
      this.elError = this.querySelector('.js-error');

      if (this.blockType === 'embed') {
        this.initFormEmbed();
      }

      if (this.blockType === 'section') {
        // アコーディオンは必ず先。initFormSection 内で例外が出ると従来ここに到達しなかった。
        this.initPointAccordion();
        try {
          this.initFormSection();
        } catch (e) {
          console.error('[mr-point] initFormSection', e);
        }
      }
    }

    initFormSection() {
      this.initContent();
      this.setUsePointEvent();
      if (this.elResetButton) {
        this.setResetEvent();
      }
    }

    initFormEmbed() {
      const elHeader = this.querySelector('.js-header');
      if (!elHeader || !this.elContainer) return;
      elHeader.addEventListener('click', () => {
        if (!this.elContainer.classList.contains('is-open')) {
          this.elContainer.classList.add('is-open');
          this.elContainer.classList.add('is-loading');

          this.initContent();
        } else {
          this.elContainer.classList.remove('is-open');
        }
      });

      this.setUsePointEvent();
      if (this.elResetButton) {
        this.setResetEvent();
      }
    }

    setUsePointEvent() {
      if (!this.elUseButton || !this.elUsePointInput || !this.elError) {
        return;
      }
      this.elUseButton.addEventListener('click', () => {
        const usePoint = this.elUsePointInput.value;
        if (!usePoint) {
          this.elError.innerHTML = this.emptyErrorMessage;
          return;
        }
        this.elUsePoint.classList.add('is-apply');
        this.elContainer.classList.add('is-loading');
        this.elApplyPointValue.innerHTML = usePoint.toLocaleString();
        this.elError.innerHTML = '';

        const requestJson = {
          secret_key: this.secretKey,
          usepoint: usePoint,
          customer_id: this.customerId,
        };
        this.commonajax('/apps/mrpoint/coupon_generate', requestJson, this.applyDiscount.bind(this), null);
      });
    }

    initContent() {
      const requestJson = {
        secret_key: this.secretKey,
        customer_id: this.customerId,
        tags: JSON.stringify(this.customerTags),
        total_spent: this.totalSpent,
      };

      this.commonajax('/apps/mrpoint/coupon_generate', requestJson, this.renderPointContent.bind(this), null);

      // sessionStorageに使用ポイントのデータがある場合は、表示を切り替える
      this.renderApplyPoint();
    }

    renderPointContent(data) {
      if (data.err) {
        const timeoutMessage = '接続エラー。ページを更新してください。';
        this.renderError(data, timeoutMessage);
      } else {
        if (this.elContainer) this.elContainer.classList.remove('is-loading');
        if (this.elCurrentPointValue) this.elCurrentPointValue.innerHTML = data.point.toLocaleString();
        if (this.elRankValue) {
          this.elRankValue.innerHTML = data.rank_name.toLocaleString();
        }
      }
    }

    applyDiscount(data, param) {
      if (data.err) {
        const timeoutMessage = '接続エラー。再度お試しください。';
        this.renderError(data, timeoutMessage);
      } else {
        // クーポンを適用後、セッションストレージにデータを追加し表示を切り替える。
        fetch(`/discount/${data.coupon_code}`)
          .then((json) => {
            sessionStorage.setItem('mrpointUsePoint', data.usepoint);
            sessionStorage.setItem('mrpointAppliedAt', new Date().getTime());

            this.renderApplyPoint(data.usepoint);
            this.updateCartContents();
          })
          .catch((err) => {});
      }
    }

    renderApplyPoint(applyPoint = null) {
      let applyPointValue = applyPoint;
      let pointAppliedAt;
      if (!applyPoint) {
        applyPointValue = sessionStorage.getItem('mrpointUsePoint');
        pointAppliedAt = sessionStorage.getItem('mrpointAppliedAt');
      }

      // 有効期限チェック。有効期限を超えていた場合は、sessionStorageのデータを削除し処理終了
      if (applyPointValue && pointAppliedAt) {
        const now = new Date().getTime();
        const elapsedTime = now - Number(pointAppliedAt);
        const validPeriod = 24 * 60 * 60 * 1000; // 24時間
        if (elapsedTime > validPeriod) {
          sessionStorage.removeItem('mrpointUsePoint');
          sessionStorage.removeItem('mrpointAppliedAt');
          return;
        }
      }

      // 表示切り替え
      if (applyPointValue && this.elDiscountValue && this.elUseButton && this.elUsePointInput && this.elContainer && this.elUsePoint) {
        this.elDiscountValue.textContent = applyPointValue;
        this.elUseButton.textContent = this.elUseButton.dataset.updatePointText;
        this.elUsePointInput.value = '';
        this.elContainer.classList.remove('is-loading');
        this.elUsePoint.classList.remove('is-apply');
        this.elUsePoint.classList.add('is-discount');
      }
    }

    renderError(data, timioutMessage) {
      if (this.elContainer) this.elContainer.classList.remove('is-loading');
      if (this.elUsePoint) this.elUsePoint.classList.remove('is-apply');
      const message = data.err == 'TIMEOUT' ? timioutMessage : data.err;
      if (this.elError) this.elError.innerHTML = message;
    }

    setResetEvent() {
      this.elResetButton.addEventListener('click', () => {
        this.elContainer.classList.add('is-loading');

        this.commonajax('/apps/mrpoint/reset_use_point', {}, this.resetDiscount.bind(this), null);
      });
    }

    resetDiscount() {
      // 存在しないクーポンコードを適用させ、ディスカウントを解除してからカートの表示を更新する。
      const NON_EXISTENT_COUPON_CODE = 'NON_EXISTENT_COUPON_CODE';
      fetch(`/discount/${NON_EXISTENT_COUPON_CODE}`)
        .then((json) => {
          sessionStorage.removeItem('mrpointUsePoint');
          sessionStorage.removeItem('mrpointAppliedAt');
          this.elDiscountValue.textContent = '';
          this.elUseButton.textContent = this.elUseButton.dataset.usePointText;
          this.elUsePointInput.value = '';
          this.elContainer.classList.remove('is-loading');
          this.elUsePoint.classList.remove('is-discount');

          this.updateCartContents();
        })
        .catch((err) => {});
    }

    //-----------------------------------------------
    // jquery使わない式のajax
    // @param url   リクエスト先
    // @param requestJson リクエストデータ(json形式)
    // @param callback 取得後実行処理
    // @param cbparam 取得後実行処理に対する引数
    //-----------------------------------------------
    commonajax(url, requestJson, callback, cbparam) {
      const controller = new AbortController();
      const timeout = setTimeout(() => {
        controller.abort();
      }, 10000);

      fetch(url, {
        method: 'POST',
        body: JSON.stringify(requestJson),
        headers: { 'Content-Type': 'application/json; charset=utf-8' },
        signal: controller.signal,
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          if (callback) callback(data, cbparam);
        })
        .catch(function (err) {
          if (err.name == 'AbortError') {
            if (callback) callback({ err: 'TIMEOUT' }, null);
          } else {
            if (callback) callback({ err: 'ERROR' }, null);
          }
        });
    }

    // ディスカウント額が変わるためフッター部分を更新
    updateCartContents() {
      const targetSection = 'cart-drawer';

      fetch(`?sections=${targetSection}`)
        .then((response) => response.text())
        .then((responseText) => {
          const responseData = JSON.parse(responseText);
          const cartDrawerHtml = responseData[targetSection];
          const html = new DOMParser().parseFromString(cartDrawerHtml, 'text/html');
          const selectors = ['.cart-drawer__footer'];

          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);

            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((error) => {
          console.error('カートの更新中にエラーが発生しました:', error);
        });
    }

    initPointAccordion() {
      if (this._accordionBound) return;
      this._accordionBound = true;

      // 子の span クリックも拾うよう、ホスト要素で委譲（バブリング前提）
      this.addEventListener('click', (e) => {
        const header = e.target.closest('.js-header');
        if (!header || !this.contains(header)) return;
        const elContent = this.querySelector('.js-content');
        if (!elContent) return;
        e.preventDefault();
        header.classList.toggle('is-open');
        elContent.classList.toggle('is-open');
      });
    }
  }

  customElements.define('mr-point', MrPoint);
}
